﻿import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const FilesList = ({
  files,
  onFileRemove,
}: {
  files: File[];
  onFileRemove?: (index: number) => void;
}) => (
  <>
    {files.length > 0 && (
      <List sx={{ mt: 2 }}>
        {files
          .filter((file) => file !== null && file !== undefined)
          .map((file, index) => (
            <ListItem
              key={`${file.name}-${index}`}
              sx={{
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                mb: 1,
              }}
              secondaryAction={
                onFileRemove && (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      onFileRemove(index);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                )
              }
            >
              <ListItemText
                primary={file.name}
                secondary={formatFileSize(file.size)}
              />
            </ListItem>
          ))}
      </List>
    )}
  </>
);
